import React from 'react'
import DatePicker from 'react-datepicker'
import NumberFormat from 'react-number-format'
import styled from 'styled-components'
import get from 'lodash/get'
import {
  Label,
  Button,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Container,
  Row,
  Col,
} from 'reactstrap'
import * as CONSTANTS from './constants'

class EditSubcontractCost extends React.Component {
  state = { activeTab: '1' }

  render() {
    const isEdit = get(this.props, 'isEdit')
    const user = get(this.props, 'user')
    const cost = get(this.props, 'cost')
    const price = get(this.props, 'price')
    const start_date = get(this.props, 'start_date')
    const end_date = get(this.props, 'end_date')
    const handleEditInput = get(this.props, 'handleEditInput')
    const handleClose = get(this.props, 'handleClose')
    const clickEdit = get(this.props, 'clickEdit')
    const editSubcontractCost = get(this.props, 'editSubcontractCost')
    return (
      /* eslint no-underscore-dangle: 0 */
      <Background>
        <Nav tabs>
          <NavItem>
            <NavLink>
              Subcontract Rate Information
            </NavLink>
          </NavItem>
          <Image
            src={ CONSTANTS.CLOSE_ICON }
            onClick={ () => handleClose() }
          />
        </Nav>
        <TabContent activeTab={ this.state.activeTab } >
          <TabPane tabId="1">
            <Row>
              <Col sm="12">
                <Container>
                  <Row style={ { marginTop: 10 } }>
                    <Col sm={ 3 }>
                      <TextLabel >Subcontractor Name</TextLabel>
                    </Col>
                    <Col sm={ 9 }>
                      <NameText>{ user }</NameText>
                    </Col>
                  </Row>
                  <Row style={ { marginTop: 10 } }>
                    <Col sm={ 3 }>
                      <TextLabel >Start Date</TextLabel>
                    </Col>
                    <Col sm={ 9 }>
                      <ColDate>
                        <CustomDatePicker
                          disabled={ !isEdit }
                          autoComplete='off'
                          onChange={ (e) => handleEditInput(e, 'start_date') }
                          name="start_date"
                          placeholderText='DD/MM/YYYY'
                          selected={ start_date }
                          dateFormat="DD/MM/YYYY"
                          showYearDropdown
                          showMonthDropdown
                        />
                      </ColDate>
                    </Col>
                  </Row>
                  <Row style={ { marginTop: 10 } }>
                    <Col sm={ 3 }>
                      <TextLabel>End Date</TextLabel>
                    </Col>
                    <Col sm={ 9 }>
                      <ColDate>
                        <CustomDatePicker
                          disabled={ !isEdit }
                          autoComplete='off'
                          onChange={ (e) => handleEditInput(e, 'end_date') }
                          name="end_date"
                          placeholderText='DD/MM/YYYY'
                          selected={ end_date }
                          dateFormat="DD/MM/YYYY"
                          showYearDropdown
                          showMonthDropdown
                        />
                      </ColDate>
                    </Col>
                  </Row>
                  <Row style={ { marginTop: 10 } }>
                    <Col sm={ 3 }>
                      <TextLabel >Cost/MD</TextLabel>
                    </Col>
                    <Col sm={ 9 }>
                      <ColDate>
                        <NumberField
                          disabled={ !isEdit }
                          name="cost"
                          value={ cost }
                          allowEmptyFormatting={ true }
                          thousandSeparator={ true }
                          decimalScale={ 2 }
                          fixedDecimalScale={ true }
                          onChange={ (e) => {
                            e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                            handleEditInput(e)
                          } }
                        />
                      </ColDate>
                    </Col>
                  </Row>
                  <Row style={ { marginTop: 10 } }>
                    <Col sm={ 3 }>
                      <TextLabel>Price/MD</TextLabel>
                    </Col>
                    <Col sm={ 9 }>
                      <ColDate>
                        <NumberField
                          disabled={ !isEdit }
                          name="price"
                          value={ price }
                          allowEmptyFormatting={ true }
                          thousandSeparator={ true }
                          decimalScale={ 2 }
                          fixedDecimalScale={ true }
                          onChange={ (e) => {
                            e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                            handleEditInput(e)
                          } }
                        />
                      </ColDate>
                    </Col>
                  </Row>
                  <ButtonGroup>
                    { !isEdit &&
                      <CustomButton
                        bg='#5CB85C'
                        onClick={ () => clickEdit('edit') }
                      >Edit</CustomButton>
                    }
                    { isEdit &&
                      <CustomButton
                        bg='#5CB85C'
                        onClick={ () => editSubcontractCost() }
                      >Save</CustomButton> }
                    { isEdit &&
                      <CancelButton
                        bg='white'
                        onClick={ () => clickEdit('cancel') }
                      >Cancel</CancelButton> }
                  </ButtonGroup>
                </Container>
              </Col>
            </Row>
          </TabPane>
        </TabContent>
      </Background>
    )
  }
}

export default EditSubcontractCost

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin: 15px;
`
const TextLabel = styled(Label)`
  font-family: Gotham-Bold;
  font-size: 12px ;
  color: #333333;
  margin-bottom: 0px ;
`
const NameText = styled(TextLabel)`
  font-family: Gotham;
`
const Background = styled.div`
  background-color: white;
  font-family: Gotham-Bold;
  font-size: 14px ;
  margin-left: 10px;
  margin-right: 10px;
  // max-height: calc(100vh - 200px);
  // overflow-y: scroll;
`
const NumberField = styled(NumberFormat)`
  font-family: Gotham;
  text-align: right;
  width : 100%;
  heigth: 100%;
  font-size: 14px;
  padding-right: 2%;
  border-radius: 5px;
  border: 1px solid #CCCCCC;
  background-color: ${props => {
    if (props.disabled) {
      return '#E8ECEF'
    }
    return '#FFFFFF'
  }};
`
const ColDate = styled(Col)`
  width : 100%;
  padding-left: 0px;
`
const CustomDatePicker = styled(DatePicker)`
  font-family: Gotham;
  width : 150px;
  height : 30px;
  font-size: 12px;
  padding-left: 5%;
  border-radius: 5px;
  border: ${props => {
    const status = props.selected
    if (status === '' || status === null) {
      return '1px solid #D9534F'
    }
    return '1px solid #CCCCCC'
  }};
  background-color: ${props => {
    const bg = props.disabled
    if (bg === !get(this.props, 'edit_project_info')) {
      return '#E8ECEF'
    }
    return '#FFFFFF'
  }};
  @media (max-width: 575.98px) {
    width: 100%;
  }
`
const Image = styled.img`
  width: 20px;
  height: 20px;
  position: absolute;
  right: 10px;
`
const CustomButton = styled(Button)`
  font-family: Gotham;
  font-size: 12px;
  margin: 5px;
  background-color: ${props => { return props.bg }};
  &:hover {
    background-color: #333333;
    color: #ffffff;
    border-color: #CCCCCC;
    }
`
const CancelButton = styled(CustomButton)`
  color: black;
`



// WEBPACK FOOTER //
// ./src/components/subcontract-cost/edit-subcontract-cost.js